<template>
  <b-modal
    size="lg"
    v-model="show"
    static
  >
    <template v-slot:modal-title>
      {{title}}
    </template>
    <template v-slot:modal-header-close>
      <button
        type="button"
        aria-label="Close"
        class="close"
      >
          <span class="material-icons">
            close
          </span>
      </button>
    </template>
    <div class="table_theme-info" v-if="items">
      <table>
        <template v-for="(field, index) in tableRowModalFields">
          <tr :key="index">
            <slot
              v-if="field.type === 'slot'"
              :name="`rowModal.${field.slotName}`"
              :field="getRowData(items, field.key)"
            >
            </slot>
            <template v-else>
              <td class="table__label">{{ field.label }}</td>
              <td>
                {{ getRowData(items, field.key) }}
              </td>
            </template>
          </tr>
        </template>
      </table>
    </div>
    <template v-slot:modal-footer>
      <b-button variant="primary" class="button" @click.prevent="show=false">Close</b-button>
    </template>
  </b-modal>
</template>

<script>

export default {
  name: 'TableRowModal',
  data () {
    return {}
  },
  props: {
    tableRowModalFields: {
      type: Array
    },
    title: {
      type: String,
      default: 'Table row data'
    },
    items: {
      type: Object
    },
    value: {
      type: Boolean
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    getRowData (obj, path) {
      return path.split('.').reduce((prev, curr) => {
        return prev ? prev[curr] : null
      }, obj)
    }
  }
}
</script>

<style lang="scss">
  .entities-table-row-modal {
    width: 100%;
    td {
      padding: 10px;
      border: 1px solid lightgray
    }
  }
  .entities-table-row-modal__label{
    min-width: 250px;
  }
</style>
